// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// import AdminProfile from "../user/AdminProfile";
// import { BLOG_CATEGORIES } from "../../constants/constants";
// import { Helmet } from "react-helmet-async";
// import { useCreateBlogMutation } from "../../redux/api/blogsApi";

// const NewBlog = () => {
//   const navigate = useNavigate();
//   const [blog, setBlog] = useState({
//     name: "",
//     description: "",
//     category: BLOG_CATEGORIES[0] || "",
//     author: "",
//   });

//   const { name, description, category, author } = blog;
//   const [createBlog, { isLoading, error, isSuccess }] = useCreateBlogMutation();

//   useEffect(() => {
//     if (error) toast.error(error?.data?.message);
//     if (isSuccess) {
//       toast.success("Blog created successfully!");
//       navigate("/admin/blogs");
//     }
//   }, [error, isSuccess, navigate]);

//   const onChange = (e) => {
//     setBlog({ ...blog, [e.target.name]: e.target.value });
//   };

//   const submitHandler = (e) => {
//     e.preventDefault();
//     createBlog(blog);
//   };

//   return (
//     <AdminProfile>
//       <Helmet>
//         <title>Create Blog</title>
//         <meta name="robots" content="noindex, nofollow" />
//       </Helmet>

//       <div className="w-full mt-10  sm:px-6 lg:px-8">
//         <h1 className="text-2xl font-playfair text-stone-900 mb-6">
//           Create New Blog
//         </h1>

//         <form
//           onSubmit={submitHandler}
//           className="bg-white border border-stone-200 shadow rounded-lg p-6 space-y-6 "
//         >
//           {/* Grid Layout for Inputs */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 ">
//             <div>
//               <label className="block text-sm font-medium text-stone-800 mb-1">
//                 Blog Title
//               </label>
//               <input
//                 type="text"
//                 name="name"
//                 value={name}
//                 onChange={onChange}
//                 required
//                 className="w-full px-4 py-2 border border-stone-300 rounded-md focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
//                 placeholder="Enter blog title"
//               />
//             </div>

//             <div className="flex items-end">
//               <label className="sr-only" htmlFor="category_field">
//                 Category
//               </label>
//               <select
//                 id="category_field"
//                 name="category"
//                 value={category}
//                 onChange={onChange}
//                 className="w-full px-4 py-2 border border-stone-300 rounded-md focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
//               >
//                 {BLOG_CATEGORIES.map((cat) => (
//                   <option key={cat} value={cat}>
//                     {cat}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-stone-800 mb-1">
//                 Author
//               </label>
//               <input
//                 type="text"
//                 name="author"
//                 value={author}
//                 onChange={onChange}
//                 required
//                 className="w-full px-4 py-2 border border-stone-300 rounded-md focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
//                 placeholder="Author name"
//               />
//             </div>
//           </div>

//           {/* Description */}
//           <div >
//             <label className="block text-sm font-medium text-stone-800 mb-1">
//               Main Content
//             </label>
//             <ReactQuill
//               theme="snow"
//               value={description}
//               onChange={(value) => setBlog({ ...blog, description: value })}
//               placeholder="Write your blog post here..."
//               modules={{
//                 toolbar: [
//                   [{ header: [1, 2, 3, false] }],
//                   ["bold", "italic", "underline", "strike", "blockquote"],
//                   [{ list: "ordered" }, { list: "bullet" }],
//                   ["link", "image", "video"],
//                   ["clean"],
//                 ],
//               }}
//               formats={[
//                 "header",
//                 "bold",
//                 "italic",
//                 "underline",
//                 "strike",
//                 "blockquote",
//                 "list",
//                 "bullet",
//                 "link",
//                 "image",
//                 "video",
//               ]}
//               onFocus={() => console.log("Editor focused")}
//               onBlur={() => console.log("Editor blurred")}
//               className=" border border-stone-300 rounded-md h-auto"
//             />
//           </div>

//           {/* Submit Button */}
//           <button
//             type="submit"
//             disabled={isLoading}
//             className="w-full py-3 px-4 rounded-md bg-[#BC3F4A] text-white font-playfair hover:bg-[#a3323b] transition disabled:opacity-50"
//           >
//             {isLoading ? "Creating..." : "Create Blog"}
//           </button>
//         </form>
//       </div>
//     </AdminProfile>
//   );
// };

// export default NewBlog;

import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";

import AdminProfile from "../user/AdminProfile";
import { BLOG_CATEGORIES } from "../../constants/constants";
import { Helmet } from "react-helmet-async";
import { useCreateBlogMutation } from "../../redux/api/blogsApi";

const NewBlog = () => {
  const navigate = useNavigate();
  const quillRef = useRef(null);

  const [blog, setBlog] = useState({
    name: "",
    description: "",
    category: BLOG_CATEGORIES[0] || "",
    author: "",
  });

  const { name, description, category, author } = blog;
  const [createBlog, { isLoading, error, isSuccess }] = useCreateBlogMutation();

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
    if (isSuccess) {
      toast.success("Blog created successfully!");
      navigate("/admin/blogs");
    }
  }, [error, isSuccess, navigate]);

  const onChange = (e) => {
    setBlog({ ...blog, [e.target.name]: e.target.value });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    createBlog(blog);
  };

  // Custom image handler for ReactQuill
  const imageHandler = () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();
  
    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;
  
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error("Image size should be less than 5MB");
        return;
      }
  
      // Validate file type
      if (!file.type.startsWith("image/")) {
        toast.error("Please select a valid image file");
        return;
      }
  
      // Show loading toast
      const loadingToast = toast.loading("Uploading image...");
  
      try {
        // Convert file to base64
        const reader = new FileReader();
        
        reader.onload = async () => {
          try {
            const base64Image = reader.result;
  
            console.log("Uploading image..."); // Debug log
            console.log("Base64 length:", base64Image.length); // Debug log
  
            // Upload to backend
            const { data } = await axios.post(
              "/api/v1/upload/editor-image",
              { image: base64Image },
              {
                headers: {
                  "Content-Type": "application/json",
                },
                withCredentials: true, // Important for authentication
              }
            );
  
            console.log("Upload response:", data); // Debug log
  
            if (data.success) {
              // Get Quill editor instance
              const quill = quillRef.current.getEditor();
              const range = quill.getSelection(true);
  
              // Insert uploaded image URL
              quill.insertEmbed(range.index, "image", data.url);
  
              // Move cursor after image
              quill.setSelection(range.index + 1);
  
              toast.success("Image uploaded successfully", { id: loadingToast });
            } else {
              toast.error("Upload failed", { id: loadingToast });
            }
          } catch (err) {
            console.error("Upload error:", err);
            console.error("Error response:", err.response?.data); // Debug log
            
            const errorMessage = err.response?.data?.message || "Image upload failed";
            toast.error(errorMessage, { id: loadingToast });
          }
        };
  
        reader.onerror = (error) => {
          console.error("FileReader error:", error);
          toast.error("Failed to read image", { id: loadingToast });
        };
  
        reader.readAsDataURL(file);
        
      } catch (err) {
        console.error("Unexpected error:", err);
        toast.error("An unexpected error occurred", { id: loadingToast });
      }
    };
  };
  
  // Memoize modules to prevent re-creation on every render
  // This is CRITICAL to prevent the editor from losing focus/content
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image", "video"],
          ["clean"],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    [] // Empty dependency array - modules config doesn't depend on any state
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "image",
    "video",
  ];

  return (
    <AdminProfile>
      <Helmet>
        <title>Create Blog</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="w-full mt-10 sm:px-6 lg:px-8">
        <h1 className="text-2xl font-playfair text-stone-900 mb-6">
          Create New Blog
        </h1>

        <form
          onSubmit={submitHandler}
          className="bg-white border border-stone-200 shadow rounded-lg p-6 space-y-6"
        >
          {/* Grid Layout for Inputs */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-stone-800 mb-1">
                Blog Title
              </label>
              <input
                type="text"
                name="name"
                value={name}
                onChange={onChange}
                required
                className="w-full px-4 py-2 border border-stone-300 rounded-md focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
                placeholder="Enter blog title"
              />
            </div>

            <div className="flex items-end">
              <label className="sr-only" htmlFor="category_field">
                Category
              </label>
              <select
                id="category_field"
                name="category"
                value={category}
                onChange={onChange}
                className="w-full px-4 py-2 border border-stone-300 rounded-md focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
              >
                {BLOG_CATEGORIES.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-stone-800 mb-1">
                Author
              </label>
              <input
                type="text"
                name="author"
                value={author}
                onChange={onChange}
                required
                className="w-full px-4 py-2 border border-stone-300 rounded-md focus:border-[#BC3F4A] focus:ring-[#BC3F4A] focus:outline-none text-sm"
                placeholder="Author name"
              />
            </div>
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm font-medium text-stone-800 mb-1">
              Main Content
            </label>
            <ReactQuill
              ref={quillRef}
              theme="snow"
              value={description}
              onChange={(value) => setBlog({ ...blog, description: value })}
              placeholder="Write your blog post here..."
              modules={modules}
              formats={formats}
              className="border border-stone-300 rounded-md h-auto"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-3 px-4 rounded-md bg-[#BC3F4A] text-white font-playfair hover:bg-[#a3323b] transition disabled:opacity-50"
          >
            {isLoading ? "Creating..." : "Create Blog"}
          </button>
        </form>
      </div>
    </AdminProfile>
  );
};

export default NewBlog;